export const shotgun = new Audio('/assets/mp3/shotgun.mp3');
export const dominating = new Audio('/assets/mp3/dominating.mp3');
export const firstBlood = new Audio('/assets/mp3/first-blood.mp3');
export const headshot = new Audio('/assets/mp3/headshot.mp3');
export const monsterKill = new Audio('/assets/mp3/monster-kill.mp3');
export const unstoppable = new Audio('/assets/mp3/unstoppable.mp3');
export const prepareForBattle = new Audio('/assets/mp3/prepare-for-battle.mp3');
